import { Reveal } from "./Reveal";
import { ABOUT_POINTS } from "./data";

export const About = () => {
  return (
    <section id="approach" className="bg-[#0B3D2E] py-24 md:py-36" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Image */}
        <Reveal>
          <div className="relative" data-testid="about-image-wrap">
            <div className="absolute -bottom-8 -right-8 w-56 h-56 rounded-full border border-[#F2EDE1]/20 pointer-events-none hidden md:block" />
            <div className="relative overflow-hidden aspect-[4/3] md:aspect-square">
              <img
                src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=80"
                alt="Horizon at dusk — a longer view"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B3D2E]/90 via-[#0B3D2E]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 p-7 md:p-9">
                <p className="eyebrow text-[#A6874E] mb-4">Growth Through Strategy</p>
                <p className="font-grotesk font-bold uppercase text-[#F2EDE1] text-2xl md:text-3xl leading-[1.05] tracking-tight max-w-xs">
                  Clear thinking. Careful execution. A longer view.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Copy */}
        <div>
          <Reveal>
            <span className="eyebrow text-[#A6874E]">A Little About Us</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2
              className="mt-8 font-grotesk font-bold uppercase text-[#F2EDE1] leading-[0.98] tracking-tight text-4xl sm:text-5xl"
              data-testid="about-heading"
            >
              Built around your next chapter.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 space-y-4 text-xs md:text-sm leading-relaxed text-[#F2EDE1]/60 max-w-xl">
              <p>
                Elevora is a digital growth agency for businesses ready to be more
                deliberate about what comes next. We bring strategy and hands-on digital
                work into the same conversation, so each decision has a reason and each
                effort has somewhere to lead.
              </p>
              <p>
                No borrowed playbook. No promise of overnight transformation. Just
                thoughtful partnership, clear priorities and work that earns its place.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-12 grid grid-cols-2">
              {ABOUT_POINTS.map((p, i) => (
                <div
                  key={p.num}
                  className="flex items-center gap-4 py-5 border-t border-[#F2EDE1]/15 pr-6"
                  data-testid={`about-point-${i}`}
                >
                  <span className="text-[10px] tracking-[0.25em] text-[#A6874E] font-medium">{p.num}</span>
                  <span className="text-xs md:text-sm text-[#F2EDE1]/80">{p.text}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
